// const API_URL = "https://apis1.foodlocation.co/api/";
const API_URL = "https://apil.foodlocation.co/api/";
// const API_URL = "http://45.94.58.37:5002/api/";
export default API_URL;
